import { useState, useCallback } from 'react';
import { pwd210Api } from '../../../services/pwd210Api';

export function usePwd210Navigation(onNavigate: (id: string) => Promise<void>) {
  const [allIds, setAllIds] = useState<string[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  /** Load the full list of IDs */
  const loadList = useCallback(async (): Promise<string[]> => {
    const ids: string[] = [];
    for (let page = 1; ; page += 1) {
      const res = await pwd210Api.list(page, 100);
      const batch = (res.data || []).map(r => r.fd210_01).filter(Boolean);
      ids.push(...batch);
      if (batch.length === 0 || ids.length >= res.total) break;
    }
    setAllIds(ids);
    return ids;
  }, []);

  /** Navigate to a specific index */
  const navTo = useCallback(async (idx: number, isEditing: boolean) => {
    if (idx < 0 || idx >= allIds.length || isEditing) return;
    setCurrentIdx(idx);
    await onNavigate(allIds[idx]);
  }, [allIds, onNavigate]);

  return {
    allIds, currentIdx,
    setAllIds, setCurrentIdx,
    loadList, navTo,
  };
}
